import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import styles from './LogicActionsStyles.module.css';
import Button from 'components/Button';
import SelectionPopper from 'components/poppers/SelectionPopper';
import { surveyEditorTexts } from 'utils/appTexts';
import { assignmentOperators } from '../LogicConfiguration';

const texts = surveyEditorTexts.properties.logic.itemEditor.actions.assignment;

export const dataTypes = {
    NUMBER: ['=','+=','-=' ,'*=','/=' ,'%=', '**='],
    STRING: ['=','+='],
    BOOLEAN: ['='],
    ARRAY: [],
}

export default function AssignmentOperator({dataType = dataTypes.NUMBER, operator, onChange, disabled}) {

    const btnRef = useRef();

    const [isPopperActive, setIsPopperActive] = useState( false );

    const options = useMemo( () => {
        return dataType.map( ( op ) => {
            return (
                <span key={ op } > 
                    <span className={ styles.assignmentIcon }> { op } </span> 
                    { texts[ assignmentOperators[op] ][ 'en' ] } 
                </span>
            )
        })
    }, [dataType])

    useEffect( () => {

        if( !dataType.includes( operator ) ) {
            onChange( dataType[ 0 ]);
        }

    }, [operator, dataType, onChange])

    const handleSelect = useCallback( (selected) => {

        onChange( selected );
        setIsPopperActive( false );

    }, [onChange])

    return (
        <>
            <div ref={ btnRef } className={ styles.assignmentBtnCont }>
                    <Button
                        label={ operator }
                        tooltip={ texts.assignmentOperatorTooltip[ 'en' ] }
                        theme='Plain'
                        colorSet='Grayscale'
                        bgStyle={{
                            padding: '4px 8px',
                            height: 32,
                        }}
                        labelStyle={{ 
                            fontFamily: 'Plex-Mono',
                            fontWeight: 700,
                            fontSize: 16,
                            marginBottom: 4,
                            color: `var( --color-type-${disabled ? 'low' : 'high'}-emphasis )`
                        }}
                        onClick={ () => setIsPopperActive( true ) }
                        disabled={ disabled }
                    />
            </div>
            <SelectionPopper
                isActive={ isPopperActive }
                referenceElement={ btnRef.current }
                onDismiss={ () => setIsPopperActive( false ) }
                onSelect={ handleSelect }
                dir='ltr'
            >
                { options }
            </SelectionPopper>
        </>
    )
}